<template>
  <!--  -->
  <div class="side-panel left com-left hf osy ml-30">
    <div class="side-panel-bg">
      <div class="pt-20 pl-20 pb-5 pr-20  thisMonthData">
        <h1 class="f-20 c-satwo">算力运行 <img src="/imgs/titleicon.png" class="ml-10"></h1>
        <h3 class="f-14 pt-20 c-satwotitle">算力设备上线率和利用率</h3>
        <div class="fr ov bleftOne" style="margin-top: -16px;">
          <chart-gauge-online :chartData="online" style="width: 100%; height: 158px;"/>
          <chart-gauge-online :chartData="usage" style="width: 100%; height: 158px;"/>
        </div>
        <div class="fr ov usage-line">
          <div class="usage-line-solid" />
          <div class="usage-line-solid" />
        </div>
        <div class="fr ov usage-label-bar">
          <div class="usage-label">{{ online.name }} {{ online.value }} P</div>
          <div class="usage-label">{{ usage.name }} {{ usage.value }} P</div>
        </div>
      </div>
      <div style="text-align: center;"><img src="/imgs/saline.png"></div>
      <div class="pt-10 pl-20 pb-5 pr-20">
        <h3 class="f-14 c-satwotitle">算力使用</h3>
        <chart-line-compusage :chartData='compUsage' style="width: 100%; height: 150px;"></chart-line-compusage>
      </div>
      <div style="text-align: center;"><img src="/imgs/saline.png"></div>
      <div class="pt-10 pl-20 pb-5 pr-20">
        <h3 class="f-14 c-satwotitle">算力任务类型</h3>
        <chart-pietwo :data1="taskType" :data2="taskType" style="height:160px;"></chart-pietwo>
      </div>
      <div style="text-align: center;"><img src="/imgs/saline.png"></div>
      <div class="pt-10 pl-20 pr-20">
        <h3 class="f-14 c-satwotitle">算力应用方向</h3>
        <div class="mt-10 bleftThree">
          <chart-rose :data="appType" style="height:210px;"></chart-rose>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import chartBarSingle from './chart-bar-single.vue'
import chartGaugeOnline from './chart-gauge-online.vue'
import chartPietwo from './chart-pietwo'
import chartRose from './chart-rose'
import chartLineCompusage from "@/views/sascreen/dc/chart-line-compusage.vue";

export default {
  name: 'com-left',
  components: {
    chartBarSingle,
    chartPietwo,
    chartRose,
    chartGaugeOnline,
    chartLineCompusage,
  },
  props: {
    resData: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      compUsage: {},
      taskType: {},
      appType: {},
      online: {},
      usage: {},
    }
  },
  mounted() {
    this.$nextTick(function () {
      // 初始化dom相关数据
      setTimeout(() => {
        this.compUsage = this.resData.compUsage
        this.taskType = this.resData.taskType
        this.appType = this.resData.appType
        this.online = this.resData.onlineUsageRate[0]
        this.usage = this.resData.onlineUsageRate[1]
      }, 300)
    })
  },
}
</script>

<style lang="scss" scoped>

.usage-line {
  width: 100%;
  height: 3px;
  border-top-style: dashed;
  border-top-color: #66FFFF;
  border-top-width: 1px;
  margin-top: -22px;
}
.usage-line-solid {
  width: 49%;
  border-top-style: solid;
  border-top-color: #66FFFF;
  border-top-width: 2px;
  margin-top: -1px;
  margin-left: 45px;
  margin-right: 45px;
}

.usage-label-bar {
  width: 100%;
  height: 32px;
  margin-top: 2px;
}
.usage-label {
  width: 48%;
  margin-top: 5px;
  margin-left: 30px;
  margin-right: 30px;
  font-size: 12px;
  text-align: center;
}

.thisMonthData {
  .bleftOne > div {
    background: url(/imgs/border-leftOne.png) no-repeat;
    width: 120px;
    height: 69px;
    background-size: 100% 69px;
  }

  .bleftTwo > div {
    background: url(/imgs/border-leftTwo.png) no-repeat;
    height: 68px;
    background-size: 100%;
  }
}

.bleftThree {
  background: url(/imgs/border-leftThree.png) no-repeat;
  height: 225px;
  background-size: 100%;
  padding: 5px 0;
}

</style>
